const focusableSelector =
  'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

/** Cycle only Tab at a dialog boundary; callers retain Escape and lifecycle ownership. */
export function cycleDialogFocus(
  event: KeyboardEvent,
  container: HTMLElement | null,
  visibleOnly = false,
) {
  if (event.key !== "Tab" || !container) return;
  const elements = Array.from(
    container.querySelectorAll<HTMLElement>(focusableSelector),
  ).filter((element) => !visibleOnly || element.getClientRects().length > 0);
  const first = elements.at(0);
  const last = elements.at(-1);
  if (!first || !last) return;
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}
